//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

//Add
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja'
import moment from 'moment';
//Action
import * as communityPostAction from '../action/communityPostAction';
//Func
import { lsPostConditionInit } from '../func/lsPostCondition';
//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ClearIcon from '@material-ui/icons/Clear';

//Part
import PartCheckbox from './PartCheckbox';
//JSON
var profileItem = require('../data/profileItem.json');

registerLocale('ja', ja);


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      sex: [],
      age: [],
      region: [],
      date: null,
      keyword: '',
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {

      let lsObj = JSON.parse(localStorage.getItem('PostCondition'));

      this.setState({
        sex: lsObj.sex,
        age: [Number(lsObj.age.low), Number(lsObj.age.high)],
        region: lsObj.region,
        date: (lsObj.date) ? new Date(lsObj.date) : null,
        keyword: (lsObj.keyword) ? lsObj.keyword : '',
      });
    }
  }

  _sexSelect() {
    let menBorderColor;
    let menBackgroundColor;
    let menTextColor;

    let womenBorderColor;
    let womenBackgroundColor;
    let womenTextColor;

    if (this.state.sex.includes('men')) {
      menBorderColor = '#4376AB';
      menBackgroundColor = '#4376AB';
      menTextColor = '#FFF';
    }
    else {
      menBorderColor = '#4376AB';
      menBackgroundColor = '#FFF';
      menTextColor = '#4376AB';
    }

    if (this.state.sex.includes('women')) {
      womenBorderColor = '#CD4695';
      womenBackgroundColor = '#CD4695';
      womenTextColor = '#FFF';
    }
    else {
      womenBorderColor = '#CD4695';
      womenBackgroundColor = '#FFF';
      womenTextColor = '#CD4695';
    }

    return (
      <div>
        <Button
          size="large"
          variant="outlined"
          onClick={ () => this._sexChange('men') }
          style={{
            color: menTextColor,
            backgroundColor: menBackgroundColor,
            borderType: 'solid',
            borderWidth: '1px',
            borderColor: menBorderColor,
            margin: '3px',
          }}
        >
          男性
        </Button>

        <Button
          size="large"
          variant="outlined"
          onClick={ () => this._sexChange('women') }
          style={{
            color: womenTextColor,
            backgroundColor: womenBackgroundColor,
            borderType: 'solid',
            borderWidth: '1px',
            borderColor: womenBorderColor,
            margin: '3px',
          }}
        >
          女性
        </Button>
      </div>
    );
  }

  _ageSelect() {
    const selectLow = [];
    const selectHigh = [];
    for (let i = 18; i <= 90; i++) {
      selectLow.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    for (let i = 90; i >= 18; i--) {
      selectHigh.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    return (
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          textAlign:'center',
          alignItems:'center',
        }}
      >
        <div style={{flex:3, textAlign:'right'}}>
          <FormControl variant="outlined">
            <Select
              value={this.state.age[0]}
              onChange={ (event) => this.setState({age:[event.target.value, this.state.age[1]]}) }
            >
              {selectLow}
            </Select>
          </FormControl>
        </div>
        <div  style={{flex:1, textAlign:'center'}}>
         〜
        </div>
        <div  style={{flex:3, textAlign:'left'}}>
          <FormControl variant="outlined">
            <Select
              value={this.state.age[1]}
              onChange={ (event) => this.setState({age:[this.state.age[0], event.target.value]}) }
            >
              {selectHigh}
            </Select>
          </FormControl>
        </div>
      </div>
    );
  }



  _regionChange(value) {
		if (!this.state.region.includes(value)) {
			this.setState({ region: [...this.state.region, value] });
		}
    else {
			this.setState({ region: this.state.region.filter((arr) => { return arr !== value }) });
		}
  }

  _sexChange(value) {
    if (!this.state.sex.includes(value)) {
      this.setState({ sex: [...this.state.sex, value] });
    }
    else {
      this.setState({ sex: this.state.sex.filter((arr) => { return arr !== value }) });
    }
  }

  _checkboxChange(stateKey, value) {
		if (!this.state[stateKey].includes(value)) {
			this.setState({ [stateKey]: [...this.state[stateKey], value] });
		}
    else {
			this.setState({ [stateKey]: this.state[stateKey].filter((arr) => { return arr !== value }) });
		}
  }

  _submit(reset) {
    if (reset) {
      lsPostConditionInit();
      this.props.communityPostListGet(1);
      this.props.onClose();
    }
    else {
      let sex;
      if (this.state.sex.length === 0) {
        sex = ['men', 'women'];
        this.setState({sex: sex});
      }
      else {
        sex = this.state.sex;
      }

      var obj = {
        sex: sex,
        age: {
          low: this.state.age[0],
          high: this.state.age[1],
        },
        region: this.state.region,
        date: (this.state.date) ? moment(this.state.date).format('YYYY-MM-DD') : null,
        keyword: this.state.keyword.replace(/　/g, " "),
      };
      localStorage.setItem('PostCondition', JSON.stringify(obj));
      this.props.communityPostListGet(1);
      this.props.onClose();
    }
  }



	render() {
    let maxDate = new Date();
    let minDate = new Date();
    minDate.setDate(minDate.getDate() - 30);
		return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={ () => this.props.onClose() }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <IconButton
                onClick={ () => this.props.onClose() }
                >
                <ArrowBackIosIcon />
              </IconButton>
              投稿条件
            </div>
            <div style={{margin:'5px'}}>
              <Button
                variant="outlined"
                color='primary'
                onClick={ () => this._submit(true) }
                size='small'
              >
                条件をリセット
              </Button>
            </div>
          </div>
        </div>

        <DialogContent style={{padding:'10px'}}>
          <div>
            <div style={{padding:'3%'}}>

              <h3>
                性別
              </h3>

              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent: 'center',
                }}
              >
                {
                  this._sexSelect()
                }
              </div>
            </div>
            <div style={{padding:'3%'}}>
              <h3  style={{padding:'0px'}}>
                年齢
              </h3>
              <div style={{textAlign:'center'}}>
              {
                this._ageSelect()
              }
              </div>
              <div style={{textAlign:'center'}}>
                <Slider
                  value={this.state.age}
                  onChange={ (e, value) => this.setState({age: value}) }
                  valueLabelDisplay="auto"
                  min={18}
                  max={90}
                  style={{width:'80%'}}
                />
              </div>
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                日付
              </h3>
              <div style={{textAlign:'center', paddingLeft:'30px'}}>
                <DatePicker
                  onChange={ (e) => this.setState({date: e}) }
                  locale="ja"
                  selected={ (this.state.date) ? this.state.date : maxDate }
                  maxDate={ maxDate }
                  minDate={ minDate }

                  customInput={
                    <Button
                      style={{fontSize:'1.2em'}}
                      variant="outlined"
                    >
                      { (this.state.date) ? moment(this.state.date).format('YYYY-MM-DD') : <span style={{color:'#999'}}>未設定</span> }
                    </Button>
                  }
                />

                <IconButton
                  onClick={ () => this.setState({date: null}) }
                >
                  <ClearIcon />
                </IconButton>
              </div>
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                キーワード
              </h3>
              <div style={{textAlign:'center'}}>
                <input
                  value={this.state.keyword}
                  onChange={ (e) => this.setState({keyword: e.target.value}) }
                  style={{fontSize:'1.2em',width:'80%'}}
                  className={ "input_blue round6" }
                />
              </div>
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                地域
              </h3>
              {
                profileItem.region.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.region.includes(value.ja)}
                    click={ (e) => this._checkboxChange('region', e) }
                  >
                    <span>{value.ja.replace(/(県)|(府)|(海外-)/g , "")}</span>
                  </PartCheckbox>
                )
              }
            </div>
          </div>
          <div style={{height:'60px'}}></div>

          <div style={{position:'fixed',bottom:'0px',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
              <div style={{padding:'10px'}}>

                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this._submit() }
                  style={{width: '100%', fontSize:'1.2em'}}
                >
                  絞り込む
                </Button>
              </div>
            </div>
          </div>

        </DialogContent>

      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...communityPostAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
